import React from 'react'
import { Badge, Pane, Text } from "evergreen-ui";
import { FaRegMoneyBillAlt } from 'react-icons/fa'

const StatusRegister_0 = () => {
    return (
        <Pane
            color="#fff"
            backgroundColor="#d6af00ff"
            height="100%"
            paddingY={4}
            paddingX={5}
            fontSize={14}
            fontFamily=""
            margin={0}
            fontWeight={700}
            justifyContent="center"
            alignItems="center"
            display="flex"
            flexDirection="row"
        >
            <FaRegMoneyBillAlt /> &nbsp; อยู่ระหว่างการชำระค่าสมัคร
        </Pane>

    )
}

export default StatusRegister_0